module.exports = __webpack_public_path__ + "img/7-Intersection 2.214811ae.png";